import React, { useEffect, useState, memo } from 'react';
import PropTypes from 'prop-types';
// @mui
import { useTheme } from '@mui/material/styles';
import { AppBar, Box, Toolbar } from '@mui/material';
import { paramCase } from 'change-case';
import { PATH_DEALER, PATH_HelpAndCommunication } from '../../../routes/paths';
import { bgBlur } from '../../../utils/cssStyles';
// components
import { NAV, HEADER } from '../../../config-global';
import { NavSectionHorizontal } from '../../../components/nav-section';
import SvgColor from '../../../components/svg-color';
import HelpService from '../../../services/helpandcommunication.service';
import NavSectionTab from './NavSectionTab';
import AppCache from '../../../services/appcache';
// ----------------------------------------------------------------------

function NavHorizontal() {

    const theme = useTheme();
    const [navConfig, setNavConfig] = useState([]);

    const icon = (name) => (
        <SvgColor src={`/Images/MenuIcons/${name}`} sx={{ width: 1, height: 1 }} />
    );

    useEffect(() => {
        const userLoginDetails = AppCache.GetUserLoginDetails();
        const payload = {
            franchise: userLoginDetails?.Franchise,
            region: userLoginDetails?.Region
        }
        HelpService.GetCategories(payload)
            .then(response => {
                const newNavConfig = response.data.map(data => ({
                    subheader: data.category,
                    items: [{
                        title: data.category,
                        // icon: icon(data.iconName),
                        path: PATH_HelpAndCommunication.helpandcommunication(data.category),
                        /*  ...(data.menus.length > 0  && {
                              children: data.menus.map(menu => ({
                                  title: menu.menuName,
                                  path: PATH_HelpAndCommunication.helpandcommunicationviewpage(data.category, menu.menuName)
                              })) 
                          }), */
                    }],
                }));

                setNavConfig(newNavConfig);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }, []); // Empty dependency array to run the effect only once

    return (
        <AppBar
            component="nav"
            color="transparent"
            sx={{
                boxShadow: 0,
                // top: HEADER.H_MOBILE,
                top: HEADER.H_DASHBOARD_DESKTOP_NEW,
            }}
        >
            <Toolbar
                sx={{
                    ...bgBlur({
                        color: theme.palette.background.default,
                    }),
                }}
            >
                {/*   <NavSectionHorizontal data={navConfig} /> */}
                <NavSectionTab data={navConfig} />
            </Toolbar>

            <Shadow />
        </AppBar>
    );
}

export default memo(NavHorizontal);

// --------------------------------------------------------------------------------------------------------------

Shadow.propTypes = {
    sx: PropTypes.object,
};

function Shadow({ sx, ...other }) {
    return (
        <Box
            sx={{
                left: 0,
                right: 0,
                bottom: 0,
                height: 24,
                zIndex: -1,
                width: 1,
                m: 'auto',
                borderRadius: '50%',
                position: 'absolute',
                boxShadow: (theme) => theme.customShadows.z8,
                ...sx,
            }}
            {...other}
        />
    );
}
